import http from '../http-common';

const API_URL_PATH = 'visible-behaviours/';
const API_URL_PATH_WITHOUT_BAR = 'visible-behaviours';

class VisibleBehavioursDataService {
  findAll(page, limit, sort = 'DESC') {
    return http.get(
      API_URL_PATH_WITHOUT_BAR + '?page=' + page + '&limit=' + limit + '&sort=' + sort
    );
  }

  findOne(id) {
    return http.get(API_URL_PATH + id);
  }

  create(visibleBehaviour) {
    return http.post(API_URL_PATH, visibleBehaviour);
  }

  update(visibleBehaviour) {
    return http.put(API_URL_PATH + visibleBehaviour.id, visibleBehaviour);
  }

  delete(id) {
    return http.delete(API_URL_PATH + id);
  }
}

export default new VisibleBehavioursDataService();
